import { CirrusReaderAppUiDefaults, type ICirrusReaderUiActionKeyCommand } from "../shared/CirrusReaderAppUiDefaults";
import { CirrusReaderNavigationType } from "../shared/CirrusReaderModel";

export const useHandleKeyboardShortcut = (code: string, key: string, altKeyPressed: boolean, shiftKeyPressed: boolean, _ctrlKeyPressed: boolean) => {
    console.log(`useHandleKeyboardShortcut() called with code: ${code}, key: ${key}, altKeyPressed: ${altKeyPressed}, shiftKeyPressed: ${shiftKeyPressed}, ctrlKeyPressed: ${_ctrlKeyPressed}`);
    if (!key || !code) {
        console.log('useHandleKeyboardShortcut: Got undefined key or code parameters.');
        return false;
    }
    const keyCommand = _resolveUiActionKeyCommand(code, key, shiftKeyPressed);
    if (!keyCommand){
        return false;
    }

    switch (key) {
        case 'ArrowLeft':
            if (useUiBlockingGate().isUiBlocking.value) return false;
            useCirrusSharedAPI().navigate({ navigationType: CirrusReaderNavigationType.PREVIOUS })
            return true;

        case 'ArrowRight':
            if (useUiBlockingGate().isUiBlocking.value) return false;
            useCirrusSharedAPI().navigate({ navigationType: CirrusReaderNavigationType.NEXT })
            return true;
    }
}

const  _resolveUiActionKeyCommand = (code: string, key: string, shiftKeyPressed: boolean): ICirrusReaderUiActionKeyCommand | undefined => {
    return CirrusReaderAppUiDefaults().options.uIActionKeyCommands?.find((keyCommand: ICirrusReaderUiActionKeyCommand) => {
        let keyCommandFound: boolean = keyCommand.key === key || `Key${keyCommand.key}`.toLowerCase() === code.toLowerCase();

        keyCommandFound = (keyCommandFound && shiftKeyPressed && keyCommand.modifiers.includes(Key.Shift)) ||
            (keyCommandFound && !shiftKeyPressed && !keyCommand.modifiers.includes(Key.Shift));

        return keyCommandFound;
    });
}